import React, { useContext, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import UserContext from "../../contexts/user";
import { AuthContext } from "../../containers/user-auth";
import { useApolloClient } from "@apollo/client";
import * as Yup from "yup";
import axios from "axios";
import { boolean } from "yup";
import AlertModal from "../../components/alert-modal";
import usePasswordToggle from "./usePasswordToggle";
import { useHistory, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ValidateUser: React.FC = () => {
  // const { event_slug } = useParams<{
  //   event_slug: string;
  const event_slug = document.location.pathname.split("/")[1] || "invalid";
  const intl = useIntl();
  const userContext = useContext(UserContext);
  const authContext = useContext(AuthContext);
  const apolloClient = useApolloClient();
  let history = useHistory();

  const { currentEvent } = userContext;
  const { login, setPage } = authContext;
  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleAlertModal = () => {
    setShowAlertModal(!showAlertModal);
  };
  const [alertType, setAlertType] = useState("");

  const [message, setMessage] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const resetCode = urlParams.get("resetcode");

  const setPageCallback = () => {
    const event_slug = document.location.pathname.split("/")[1] || "invalid";
    window.history.replaceState(null, "ESlides Schedule", "/" + event_slug);

    setPage("login");
    userContext.setShowLogin(true);
  };
  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  const toogleConfurmPassword = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };
  // const urlParams = new URLSearchParams(window.location.search);
  // const resetPassword = urlParams.get('test');
  //  console.log("resetPassword in reset.tsx",resetPassword)
  // setAlertType("wait");
  // setPptMessage(
  //   "You Version Is Online"
  //   // Chaptering is going on , please wait a moment
  // );
  // setShowAlertModal(true);
  //   const PasswordSchema = Yup.object().shape({
  //     password: Yup.string()
  //       .required()
  //       .min(
  //         6,
  //         intl.formatMessage({
  //           id: "error.atleast6",
  //         })
  //         // function () {
  //         //   setAlertType("Error");
  //         //   setMessage("password length atleast 6");
  //         //   setShowAlertModal(true);
  //         // }

  //       ),
  //     confirmPassword: Yup.string().when("password", {
  //       is: (val:any) => (val && val.length > 0 ? true : false),
  //       then: Yup.string().oneOf(
  //         [Yup.ref("password")],

  //         // intl.formatMessage({
  //         //   id: "error.passnomatch",
  //         // })
  //         // function () {
  //         //   setAlertType("Error");
  //         //   setMessage("password not matched ");
  //         //   setShowAlertModal(true);
  //         // }
  //       ),
  //     }),
  //   });
  //  console.log("PasswordSchema in resetpassword", PasswordSchema )
  return (
    // <Formik
    //   initialValues={{ code: "", password: "" }}
    //   onSubmit={async values => {
    //     try {
    //       // await Auth.forgotPasswordSubmit(forgotPasswordUsername.toLowerCase(), values.code, values.password)
    //       //setFormType('signin');
    //     } catch (e) {
    //        console.log('reset err: ', e)
    //     }
    //   }}
    //
    <>
      <Formik
        // validationSchema={PasswordSchema}

        initialValues={
          {
            // password: "",
            // confirmPassword: "",
          }
        }
        onSubmit={async (values) => {
           console.log(
            "userContext.currentEvent._id",
            userContext.currentEvent._id
          );

          await axios
            .post(
              `${process.env.REACT_APP_API_ENDPOINT}/api/event-engagement/${userContext.currentEvent._id}/user-reset-validate`,

              {
                token: resetCode,
              }
            )
            .then((response) => {
               console.log(
                "response.data.data--------------------------------------------------------------",
                response.data.data
              );
              setAlertType("Success");
              setMessage("validated");
              setShowAlertModal(true);
              // land to log in page
              setPageCallback();
            })
            .catch((error) => {
               console.log(error);
              setAlertType("Error");
              setMessage("something went wrong");
              setShowAlertModal(true);
            });
        }}
      >
        {({ isSubmitting }) => {
          return (
            <Form className="m-t-30">
              <h4>
                {/* <FormattedMessage id="resetpass.header" /> */}
                Validate User
              </h4>
              <div className="form-group">
                {/* <Field
                  required
                  // placeholder={intl.formatMessage({ id: "input.code" })}
                  placeholder={intl.formatMessage({ id: "input.newPassword" })}
                  className="form-control"
                  // type="text"
                  // type="password"
                  type={passwordShown ? "text" : "password"}
                  // type={passwordInputType}
                  name="password"
                  // onClick={togglePassword}
                  // minLength="6"
                /> */}
                {/* <button className="visible-button" onClick={togglePassword}>
                  <img src={`/images/eye.svg`} />
                </button> */}
                {/* {ToggleIcon} */}
                {/* <span onClick={togglePassword} className="visible-button">
                  <img className="visible-button-img" src={`/images/eye.svg`} />
                </span> */}
                <ErrorMessage
                  className="invalid-feedback"
                  name="password"
                  component="div"
                />
              </div>
              <div className="form-group">
                {/* <Field
                  // component={InputFloatingLabel}
                  required
                  placeholder={intl.formatMessage({
                    id: "input.confirmPassword",
                  })}
                  className="form-control"
                  // type="password"
                  type={confirmPasswordShown ? "text" : "password"}
                  // name="password"
                  name="confirmPassword"
                  minLength="6"

                  // onClick={toogleConfurmPassword}
                /> */}
                {/* {ToggleIcon} */}
                {/* <span
                  onClick={toogleConfurmPassword}
                  className="visible-button-confirm"
                >
                  <img src={`/images/eye.svg`} />

                </span> */}
                {/* <FontAwesomeIcon icon: IconProp = {confirmPasswordShown? "fa-eye" : "fa-eye"}/> */}
                {/* <button className="visible-button"  onClick={toogleConfurmPassword}>
                  <img src={`/images/eye.svg`} />
                </button> */}

                <ErrorMessage
                  className="invalid-feedback"
                  name="confirmPassword"
                  component="div"
                />
              </div>
              {/* <img  src={`/images/eye.svg`} /> */}

              <div className="login-button-container m-t-20">
                {/* <Button
                  onClick={function () {
                    userContext.setShowLogin(false);
                  }}
                  color="link"
                  type="button"
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({
                        id: "auth.continue.without.login",
                      }),
                    }}
                  ></span>
                </Button> */}
                <div style={{ marginLeft: "32%" }}>
                  <Button color="primary" type="submit" disabled={isSubmitting}>
                    {/* <FormattedMessage id="common.enter.button" /> */}
                    Validate
                  </Button>
                </div>
              </div>
              <div className="common-styles m-t-20">
                {/* <Button
                  // onClick={() => setPage("login")
                  // history.push("/" + event_slug);

                  // }
                  onClick={function () {
                    setPageCallback();
                  }}
                  color="link"
                  type="button"
                >
                  {intl.formatMessage({ id: "auth.back.to.signin" })}
                </Button> */}
              </div>
            </Form>
          );
        }}
      </Formik>
      <AlertModal
        show={showAlertModal}
        handleClose={handleAlertModal}
        type={alertType}
        message={message}
      />
    </>
  );
};

export default ValidateUser;
